import React from 'react';
import { TextField } from '@mui/material';
function MultilineTextField(props) {
    var value = props.value, onChange = props.onChange;
    var handleChange = React.useCallback(function (event) {
        onChange(event.target.value);
    }, [onChange]);
    return (React.createElement(TextField, { multiline: true, style: {
            minWidth: 200,
            width: '100%',
        }, value: value, onChange: handleChange }));
}
export default MultilineTextField;
